import { Component, OnInit, ChangeDetectorRef, ViewChild, ViewContainerRef } from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';

import { Router } from '@angular/router';
import { MenuItems } from 'src/app/shared/menu-items/menu-items';
import { NavItem } from 'src/app/models/nav-items';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

  constructor(
    public menuItems: MenuItems,
    public router: Router,
  ) {

  }


  ngOnInit(): void {

  }

  onItemSelected(item: NavItem) {
    if (!item.children || !item.children.length) {
      if (item.route === 'login') {
        localStorage.clear()
        this.router.navigate([item.route]).then(() => {
          window.location.reload();
        })
      } else {
        this.router.navigate([item.route])
      }
      item.selected = true
    }
  }

}
